import { RefObject } from "react";
import ReCAPTCHA from "react-google-recaptcha";

interface RecaptchaPropsInterface {
  recaptchaRef:RefObject<ReCAPTCHA>
  handleChangeRecaptcha: (data: any) => void;
}


export const Recaptcha = ({
  recaptchaRef,
  handleChangeRecaptcha,
}: RecaptchaPropsInterface) => {
  
  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY_TRIBUNAL_ELECTRONICO!}
      badge="inline"
      className="flex justify-center w-full mt-2"
      onChange={handleChangeRecaptcha}
    />
  );
};
